import { useEffect, useRef } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { buildClerkProfilePayload } from '../lib/clerkProfile';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://p01--astrostar-api--j9tk4rgqc56r.code.run';
//const LOCAL_API_URL = 'http://localhost:8000';

function getApiEndpoint(path: string) {
  return `${API_BASE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
}

export function useClerkToSupabaseProfile() {
  const { user, isLoaded } = useUser();
  const { getToken } = useAuth();
  const syncedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoaded || !user) {
      return;
    }

    const payload = buildClerkProfilePayload(user);

    if (syncedRef.current === user.id) {
      return;
    }

    const syncProfile = async () => {
      try {
        const token = await getToken();
        if (!token) {
          console.warn('Clerk token unavailable; skipping profile upsert.');
          return;
        }

        const response = await fetch(getApiEndpoint('/internal/upsert-profile'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            email: payload.email,
            full_name: payload.full_name,
            username: payload.username,
            avatar_url: payload.avatar_url,
          }),
        });

        const data = await response.json().catch(() => null);

        if (!response.ok) {
          console.error('Profile sync failed:', data?.detail || response.statusText);
          return;
        }

        syncedRef.current = user.id;
        console.info('Profile synced to Supabase via API:', data);
      } catch (error) {
        console.error('Unexpected error syncing clerk profile to API:', error);
      }
    };

    void syncProfile();
  }, [getToken, isLoaded, user]);
}
